import warning from './icons/Warning.svg';
import check from './icons/Check.svg';
import error from './icons/Error.svg';
import info from './icons/Info.svg';
export const notificationBannerThemes = {
    primary: {
        color: 'sf-primary',
        icon: check
    },
    warn: {
        color: 'sf-warn',
        icon: warning
    },
    error: {
        color: 'sf-error',
        icon: error
    },
    info: {
        color: 'sf-warn',
        icon: info
    }
};

export const floatingBannerThemes = {
    light: {
        background: 'sf-dark-700',
        backgroundBorder: 'sf-light-300',
        color: 'sf-light-300',
        actionButtonColor: 'sf-dark-500',
        actionButtonBorder: 'sf-light-700'
    },
    dark: {
        background: 'sf-dark-500',
        backgroundBorder: 'sf-dark-300',
        color: 'sf-light-300',
        actionButtonColor: 'sf-dark-300',
        actionButtonBorder: 'sf-light-700'
    }
};
